// extracted by mini-css-extract-plugin
module.exports = {"footerOpen":"SRPFilters_footerOpen___7M_P","move-up":"SRPFilters_move-up__vYa79","footerClose":"SRPFilters_footerClose___UtxI","move-down":"SRPFilters_move-down__ya4Hd"};